import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Globe2 = createReactComponent("Globe2", ["svg", defaultAttributes, [["path", {
  d: "M15 21v-4a2 2 0 012-2h4",
  key: "1e2agi"
}], ["path", {
  d: "M7 4v2a3 3 0 003 2h0a2 2 0 012 2 2 2 0 004 0 2 2 0 012-2h3",
  key: "xwmqo"
}], ["path", {
  d: "M3 11h2a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v4",
  key: "1lp6iw"
}], ["circle", {
  cx: "12",
  cy: "12",
  r: "10",
  key: "14id60"
}]]]);
export default Globe2;